import Vue from "vue";
import Vuex from "vuex";
import courses from './modules/CoursesModule'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    courses
  }
});
